import { initOneTrust } from "../../../services/one-trust";

export const appIdSetOneTrust = (payload) => payload?.oneTrustId && initOneTrust(payload?.oneTrustId);